import "./rack.css";
import Tile from "../Tile";
const Rack = ({tiles, boardScale, moving, mouseUp, mouseDown, mouseClick}) => {
    var scale = boardScale * 16 / 7 * .75;
    return (
<>
        
            <div id="rack" className="rackContainer" 
                onMouseMove={(event) => moving(event)}
                onMouseUp={mouseUp}
            style={{
                // paddingTop: `${18.75 * scale / 75}px`,
                width: "100%",
                margin: "0 auto"
            }}>
                <div style={{
                        width: `100%`,
                        height: `${scale}px`,
                        
                    }}
                    className="rack">
                    {tiles.map((tile, i) => (
                        <Tile 
                            key={`tile${i}`}
                            position={tile.position}
                            letter={tile.tile.letter} 
                            points={tile.tile.value} 
                            scale={scale} 
                            bottom={scale * .2}
                            onMouseDown={(event) => mouseDown(event, tile)}
                            onClick={(event) => mouseClick(event, tile)}
                        ></Tile>
                    ))}
                    <div className="rackLip" style={{height: scale / 4}}></div>
                </div>
            </div>
            
</>
    )
}

export default Rack;